import { BuildSourcesArgs, BuildSourcesReturn } from './model';

export const buildSources = ({
  preconfiguredSources,
  addConnectorData,
  chosenSource,
  editSource,
}: BuildSourcesArgs): BuildSourcesReturn[] => {
  const sources = addConnectorData.sources?.map(
    (source) => source.preconfiguredSourceName
  );

  return preconfiguredSources
    .filter((source) => source.configuration)
    .filter(
      (source) =>
        chosenSource?.name === source.name ||
        !sources?.includes(source.name) ||
        editSource === source.name
    )
    .map((source) => ({
      ...source,
      image: `/assets/connector-icons/regular-logos/${source.provider}.svg`,
      roundedImage: `/assets/connector-icons/rounded-logos/${source.provider}-rounded.svg`,
      sourceType: 'SFTP' as const,
    }));
};
